export default function AboutSection() {
  return (
    <section id="about" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-4xl mx-auto text-center">
          <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-950 mb-6">关于58影院</h2>

          <div className="prose max-w-none">
            <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-4">
              58影院成立于2024年，是一个专注于电视剧全集免费在线观看的综合平台。我们致力于为广大剧迷提供最新、最全、最高清的电视剧资源，让每一位用户都能享受无门槛的追剧体验。
            </p>
            <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-4">
              平台目前已收录超过2000部热门电视剧，涵盖国产剧、韩剧、美剧、日剧、泰剧等全品类资源，每日同步更新最新剧集。无论是热播新剧还是经典老剧，在58影院都能找到高清完整版。
            </p>
            <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-6">
              我们的使命是让追剧变得更简单、更自由。无需注册、无需付费、无需下载，打开网页即可畅享高清电视剧。58影院始终坚持为用户提供优质的免费在线看剧服务，用心打造值得信赖的追剧平台。
            </p>
          </div>

          <div className="grid grid-cols-2 sm:grid-cols-4 gap-4 mt-8">
            {[
              { num: '2000+', label: '热播剧集' },
              { num: '500万+', label: '追剧用户' },
              { num: '9大', label: '剧集分类' },
              { num: '每日更新', label: '同步上线' },
            ].map((stat) => (
              <div key={stat.label} className="p-4 rounded-xl bg-background-50 border border-background-200/60">
                <p className="text-xl md:text-2xl font-bold text-primary-500 font-heading">{stat.num}</p>
                <p className="text-xs text-foreground-500 mt-1">{stat.label}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}